import { useMemo } from "react";
import { useForm } from "react-hook-form";

export const usePasswordForm = () => {
  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
    mode: "onTouched",
  });

  // watch() gives reactive values needed for the live validation rules display
  const password = watch("password");
  const confirmPassword = watch("confirmPassword");

  const validations = useMemo(
    () => [
      {
        label: "At least 8 characters",
        valid: password.length >= 8,
      },
      {
        label: "Both passwords must match",
        valid: password === confirmPassword && confirmPassword.length > 0,
      },
      {
        label: "At least 1 uppercase & lowercase letter",
        valid: /[A-Z]/.test(password) && /[a-z]/.test(password),
      },
      {
        label: "At least 1 number & 1 special character",
        valid:
          /\d/.test(password) && /[!@#$%^&*(),.?":{}|<>]/.test(password),
      },
    ],
    [password, confirmPassword],
  );

  return { control, handleSubmit, validations };
};
